var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("page list")]),(_vm.listConfig)?_c('CampaignList',{attrs:{"lbl":_vm.lbl,"isLoading":_vm.isLoading,"initListConfig":_vm.listConfig,"initFilterConfig":_vm.filterConfig,"busEvent":_vm.busCampaign}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }